import { AppBar, Grid, IconButton, Toolbar } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

interface IModalItemSeriadoEncabezadoProps {
    cerrar: () => any;
}

const ModalSerialesEncabezado: FunctionComponent<IModalItemSeriadoEncabezadoProps> = ({ cerrar }) => (
    <AppBar color="primary" position="static">
        <Toolbar variant="dense">
            <Grid alignItems="center" container spacing={1}>
                <Grid item xs={2} />
                <Grid item xs={8}>
                    <Grid container justifyContent="center">
                        <Grid item>
                            <Texto id="ModalSerialesEncabezado.Titulo" />
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={2}>
                    <Grid container justifyContent="flex-end">
                        <Grid item>
                            <IconButton color="inherit" onClick={cerrar}>
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Toolbar>
    </AppBar>
);

export default ModalSerialesEncabezado;
